import { render } from "./EPaiement.vue?vue&type=template&id=75e04684&bindings={\"animate\":\"options\",\"onResize\":\"options\"}"
import script from "./EPaiement.vue?vue&type=script&lang=js"
export * from "./EPaiement.vue?vue&type=script&lang=js"
script.render = render

export default script